interface Props {
    statusFilter: string;
    onStatusChange: (status: string) => void;
    statusCounts: Record<string, any>;
}

const STATUSES = [
    { value: 'ACTIVE', label: 'Registrado' },
    { value: 'PENDING', label: 'Processando' },
    { value: 'QUEUED', label: 'Na fila' },
    { value: 'SENDING', label: 'Enviando' },
    { value: 'NOT_SENT', label: 'Não enviado' },
    { value: 'REJECTED', label: 'Rejeitado' },
    { value: 'FAILED_RETRYABLE', label: 'Falha (reenviável)' },
    { value: 'FAILED_PERMANENT', label: 'Falha (requer correção)' },
];

// Aggregate pseudo-filters (computed by the backend in statusCounts).
const PROBLEM_FILTERS = [
    { value: 'ERRORS', label: 'Com erro' },
    { value: 'CITY_UNRESOLVED', label: 'Cidade com problema' },
];

const CreditRightFilterSidebar = ({ statusFilter, onStatusChange, statusCounts }: Props) => {
    const cnt = (key: string): number => { const v = statusCounts[key]; return !v ? 0 : typeof v === 'object' ? v.count : v; };
    const lbl = (key: string, fallback: string): string => { const v = statusCounts[key]; return (v && typeof v === 'object' && v.label) ? v.label : fallback; };
    const totalAll = Object.entries(statusCounts)
        .filter(([k]) => k !== 'ERRORS' && k !== 'CITY_UNRESOLVED')
        .reduce((a: number, [, b]: [string, any]) => a + (typeof b === 'object' ? b.count : (b || 0)), 0);

    return (
        <div className="space-y-4">
            <button onClick={() => onStatusChange('')}
                className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${!statusFilter
                    ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 font-medium'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                <div className="flex items-center justify-between">
                    <span>Todos</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400">{totalAll}</span>
                </div>
            </button>

            <div className="border-t border-gray-200 dark:border-slate-700 pt-3">
                <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 px-3">PROBLEMAS</div>
                <div className="space-y-1">
                    {PROBLEM_FILTERS.filter(s => cnt(s.value) > 0).map(s => (
                        <button key={s.value} onClick={() => onStatusChange(statusFilter === s.value ? '' : s.value)}
                            className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${statusFilter === s.value
                                ? 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 font-medium'
                                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                            <div className="flex items-center justify-between">
                                <span>{lbl(s.value, s.label)}</span>
                                <span className="text-xs text-gray-500 dark:text-gray-400">{cnt(s.value)}</span>
                            </div>
                        </button>
                    ))}
                </div>
            </div>

            <div className="border-t border-gray-200 dark:border-slate-700 pt-3">
                <div className="text-xs font-medium text-gray-500 dark:text-gray-400 mb-2 px-3">STATUS</div>
                <div className="space-y-1">
                    {STATUSES.filter(s => cnt(s.value) > 0).map(s => (
                        <button key={s.value} onClick={() => onStatusChange(statusFilter === s.value ? '' : s.value)}
                            className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${statusFilter === s.value
                                ? 'bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-300 font-medium'
                                : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700'}`}>
                            <div className="flex items-center justify-between">
                                <span>{lbl(s.value, s.label)}</span>
                                <span className="text-xs text-gray-500 dark:text-gray-400">{cnt(s.value)}</span>
                            </div>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CreditRightFilterSidebar;
